module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAATlBMVEUAAABmZmZnZ2dnZ2dnZ2dmZmZmZmZnZ2dtbW1mZmZnZ2d1dXVmZmZmZmZmZmZnZ2dnZ2dmZmZmZmZmZmZoaGhpaWlnZ2dlZWVmZmZmZmbEtdpNAAAAGnRSTlMA/HwY5KXATRzriQSNg+8/dNDFlmUR3U4tI5whMZIAAADjSURBVFjD7dbZDoMgEAVQKJtIFdcu//+jjbFkIsTiQBrbhPskhnsS1wwpKSnZphKcHg4XVdDXFBXtC4IiIzyAYwHuARSdMwCpGFMyHWjWnU0qIN1WmQgot1UlAsxtZWcBcAmn3MTwMea/SH/wLeg2D2iIueYAl+VknQBAHwQMAH0QUAD0Q2Gwto8B0A+FfiaE3SIA9CHvZ6Gfy+LRRgDo+4JdF/cIAH1PmNyi2wegHwojLMQeAP0wk4FjM3wAanIgjO8CrSFH0n0PoOMcrxurf/OPhB8wskec7CEre8wrKSnZ5AWlyQoHzxKKlgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img.png
// module id = Tp5f
// module chunks = 2